module.exports = __webpack_public_path__ + "media/images/cleaning/cover-mobile@2x-50fc3b0e14ce25528289af2ffba8b687.jpg";